'use client';

import {useEffect} from 'react';
import {logger} from '@/lib/logger';

export default function GlobalErrorBoundary({
  error,
  reset,
}: {
  error: Error & {digest?: string};
  reset: () => void;
}) {
  useEffect(() => {
    logger.error('Kiosk page render failed', {error, digest: error.digest});
  }, [error]);

  return (
    <main
      role="alert"
      aria-label="Page render error"
      className="flex h-screen w-screen flex-col items-center justify-center gap-8 bg-phaethon-bg px-12 text-center text-phaethon-text"
    >
      <h1 className="text-display-lg">Something went wrong</h1>
      <p className="text-body-lg max-w-3xl">
        The kiosk could not load this screen. Please ask a staff member for help.
      </p>
      <button
        type="button"
        onClick={() => reset()}
        className="text-button rounded-pill border border-phaethon-text px-8 py-4"
      >
        Try again
      </button>
    </main>
  );
}
